var map = {
	"./appliance.png": 21425,
	"./bins.png": 68859,
	"./entertainment.png": 4121,
	"./heating.png": 56044,
	"./other.png": 25104,
	"./security.png": 15787,
	"./wifi.png": 6739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7907;